export default {
  namespaced: true,
  state     : {
    statistics: [
      {
        course_id           : 1,
        courses_passed      : 4,
        points_test_required: 4,
        // correct_answers     : 0,
        // wrong_answers       : 0,
        time                : 20,
        // passed              : true,
      },
    ],
  },
  getters: {
    course_id: ({course_id}) => course_id,
    // correct_answers: ({correct_answers}) => correct_answers,
    // wrong_answers  : ({wrong_answers}) => wrong_answers,
    time     : ({time}) => time,
    passed   : ({passed}) => passed,
  },
  mutations: {
    // ADD_POINT(state) {
    //   state.correct_answers += 1;
    // },
    // WRONG_ANSWER(state) {
    //   state.wrong_answers += 1;
    // },
    // TEST_PASSED(state) {
    //   state.passed = true;
    // },
    // TEST_FAILED(state) {
    //   state.passed = false;
    // },
  },
};
